import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ hasFilters, onClearFilters, onCreatePost }) => {
  if (hasFilters) {
    return (
      <div className="bg-card border border-border rounded-lg p-8 md:p-12 text-center">
        <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-muted flex items-center justify-center mx-auto mb-4">
          <Icon name="Search" size={32} color="var(--color-muted-foreground)" />
        </div>
        <h3 className="text-lg md:text-xl font-semibold text-foreground mb-2">
          No posts found
        </h3>
        <p className="text-sm md:text-base text-muted-foreground mb-6 max-w-md mx-auto">
          No posts match your current filters. Try adjusting your search criteria or clear all filters.
        </p>
        <Button
          variant="outline"
          onClick={onClearFilters}
          iconName="X"
          iconPosition="left"
          iconSize={16}
        >
          Clear All Filters
        </Button>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg p-8 md:p-12 text-center">
      <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
        <Icon name="FileText" size={32} color="var(--color-primary)" />
      </div>
      <h3 className="text-lg md:text-xl font-semibold text-foreground mb-2">
        No posts yet
      </h3>
      <p className="text-sm md:text-base text-muted-foreground mb-6 max-w-md mx-auto">
        Get started by creating your first blog post. Share your insights and technical knowledge with your audience.
      </p>
      <Button
        variant="default"
        onClick={onCreatePost}
        iconName="Plus"
        iconPosition="left"
        iconSize={16}
      >
        Create Your First Post
      </Button>
    </div>
  );
};

export default EmptyState;